<div class="row mt-3">
  <div class="col-md-3">
    <find-order-panel [panelType]="'quote'" (find)="findQuote($event)" (search)="searchQuotes($event)"></find-order-panel>
  </div>
  <div class="col-12 col-md-9" *ngLet="{currencyCode: currencyCode$ | async} as vm">
    @if (quotes$ | async; as quotes) {
      @if (!quotes.length) {
        <table>No records found.</table>
      }
      <div class="table-responsive">
        @if (quotes.length) {
          <table class="table table-striped mt-1">
            <thead>
              <tr>
                <th>Quote Number</th>
                @if (currentUser.isInternal) {
                  <th>Customer</th>
                  <th>Rewards Number</th>
                  <th>Ship To Number</th>
                }
                <th>Contact Information</th>
                <th>Branch</th>
                <th>Branch Name</th>
                <th>Created Date</th>
                <th>Expiration Date</th>
                <th>Subtotal</th>
                <th colspan="2">Status</th>
                <th>Sales Advisor Name</th>
              </tr>
            </thead>
            <tbody>
              @for (quoteItem of quotes; track quoteItem; let i = $index) {
                <tr>
                  <ng-container>
                    <td id="quote_td_quoteNumber_{{ i }}">
                      @if (!quoteItem.isLocked && quoteItem.cartId != null && quoteItem.status != OrderStatus.closed) {
                        <span>
                          <a role="button" class="hyperlink" href="javascript:void(0);"
                            (click)="goToCheckoutFromQuotesPanel(quoteItem)">{{quoteItem.orderNumber}}
                          </a>
                        </span>
                      } @else {
                        <span class="d-flex">
                          @if (commonDataService.User.id === quoteItem.updatedById && quoteItem.isLocked) {
                            <a role="button" class="hyperlink" href="javascript:void(0);" (click)="goToCheckoutFromQuotesPanel(quoteItem)">
                              {{quoteItem.orderNumber}}
                            </a>
                          } @else {
                            {{quoteItem.orderNumber}}
                          }
                          @if (quoteItem.cartId == null) {
                            <i class="fas fa-question-circle" style="padding-left: 1px;" [ngbTooltip]="quoteTipContent" [openDelay]="300" [closeDelay]="300" placement="right" tooltipClass="part-number-tooltip" [container]="'body'"></i>
                            <ng-template #quoteTipContent>
                              <div class="p-2"><b>This quote can be accessed in SAP for viewing, editing and conversion to order.</b></div>
                            </ng-template>
                          }
                        </span>
                      }
                    </td>
                    @if (currentUser.isInternal) {
                      <td id="quote_td_Customer_{{ i }}">
                        {{ isCashCustomer(quoteItem.rewardNumber) ? "RUSH CASH CUSTOMER": quoteItem.name1}}
                      </td>
                      <td id="quote_td_rewardNumber_{{ i }}" class = "ps-8">
                        {{quoteItem.rewardNumber}}
                      </td>
                      <td id="quote_td_shipToNumber_{{ i }}">
                        {{quoteItem.shipToNumber}}
                      </td>
                    }
                    <td id="quote_td_contactInfo_{{ i }}">
                      @if (quoteItem.street) {
                        <div>{{quoteItem.street}}</div>
                      }
                      @if (quoteItem.city || quoteItem.region || quoteItem.postcode) {
                        <div>
                          {{ [([quoteItem.city, quoteItem.region] | join:', '), quoteItem.postcode] | join:' ' }}
                        </div>
                      }
                      @if (quoteItem.telephone!='' && quoteItem.telephone!=' ') {
                        <span>{{quoteItem.telephone}}<br /></span>
                      }
                    </td>
                    <td id="quote_td_branchCode_{{ i }}">
                      {{quoteItem.branch}}
                    </td>
                    <td id="quote_td_branchName_{{ i }}">
                      {{quoteItem.branchName}}
                    </td>
                    <td id="quote_td_dateCreated_{{ i }}">
                      {{quoteItem.dateCreated | date: 'MM/dd/yyyy': 'UTC'}}
                    </td>
                    <td id="quote_td_expirationDate_{{ i }}">
                      {{quoteItem.expirationDate | date: 'MM/dd/yyyy': 'UTC'}}
                    </td>
                    <td id="quote_td_subtotal_{{ i }}" style="text-align: right;">
                      {{quoteItem.total | currency: vm.currencyCode }}
                    </td>
                    <td id="quote_td_orderStatus">
                      @if (quoteItem.status == OrderStatus.closed) {
                        <i class="fas fa-times" style="color:darkred;" aria-hidden="true"></i>
                      }
                      @if (quoteItem.status == OrderStatus.open) {
                        <i class="fas fa-check" style="color:forestgreen;" aria-hidden="true"></i>
                      }
                    </td>
                    <td>
                      @if (quoteItem.isLocked && commonDataService.User.id !== quoteItem.updatedById) {
                        <span class="fas fa-lock" aria-hidden="true" style="color:darkred;"></span>
                      }
                      @if (!quoteItem.isLocked || commonDataService.User.id === quoteItem.updatedById) {
                        <span class="fas fa-unlock" aria-hidden="true" style="color:forestgreen;"></span>
                      }
                    </td>
                    <td id="quote_td_salesAdvisorName">
                      @if (quoteItem.customerAdvisorFirstName) {
                        <div>{{quoteItem.customerAdvisorFirstName}}</div>
                      }
                      @if (quoteItem.customerAdvisorLastName) {
                        <div>{{quoteItem.customerAdvisorLastName}}</div>
                      }
                    </td>
                  </ng-container>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    }
  </div>
</div>
<pagination
  [currentPage]="currentPageNumber"
  idPrefix="orderHistory"
  [totalCount]="quoteCount$"
  [pageSize]="pageSize"
  (currentPageChange)="pageChange($event)">
</pagination>
